import showFlash from "flash-message";
import Routing from "utils/router";
import config from "utils/config";

module.exports = function(firstClass, secondClass, route, callback, firstMethod, secondMethod) {
    var $_firstEl = $("." + firstClass);
    var $_secondEl = $("." + secondClass);
    var $_els = $_firstEl.add($_secondEl);
    var csrfToken = config.get("csrf_token");

    $_els.on("click", function() {
        if ($(this).hasClass("btn-toggle-on")) return;

        var $firstEl, $secondEl, $nonSelectedEl, $selectedEl;
        if ($(this).hasClass(firstClass)) {
            $firstEl = $selectedEl = $(this);
            $secondEl = $nonSelectedEl = $firstEl.siblings("." + secondClass);
        } else {
            $secondEl = $selectedEl = $(this);
            $firstEl = $nonSelectedEl = $secondEl.siblings("." + firstClass);
        }

        var $els = $firstEl.add($secondEl);

        var method = $(this).hasClass(firstClass) ? firstMethod : secondMethod;
        method = method || "get";

        var self = this;
        function perform(route, callback, method) {
            $els.prop("disabled", true);

            var options = {
                url: Routing.generate(route, $(self).data()),
                data: { _csrf_token: csrfToken },
                success: function() {
                    $(self)
                        .addClass("btn-toggle-on")
                        .removeClass("btn-toggle-off");
                    $(self).addClass("c-button-group__button--selected");
                    $nonSelectedEl.addClass("btn-toggle-off").removeClass("btn-toggle-on");
                    $nonSelectedEl.removeClass("c-button-group__button--selected");

                    $nonSelectedEl.html($nonSelectedEl.data("text-off"));
                    $selectedEl.html($selectedEl.data("text-on"));

                    if (typeof callback == "function") {
                        // Quick hack
                        var approved = $(self).hasClass(secondClass);
                        callback(self, approved);
                    }
                },
                error: function(response) {
                    showFlash("warning", "Something went wrong. Contact us if the problem persists");
                },
                complete: function() {
                    $("#confirmation-modal-confirm")
                        .removeAttr("disabled")
                        .removeClass("loading");
                    $els.attr("disabled", false);
                },
            };

            if (method) {
                options.type = method;
            }

            $.ajax(options);
        }

        if ($(this).hasClass("with-confirmation")) {
            var message = $(self).data("message");
            $("#confirmation-modal-body").html(message);
            $("#confirmation-modal").modal();

            $("#confirmation-modal-confirm").on("click", function() {
                perform(route, callback, method);
            });

            $("#confirmation-modal-confirm").click(function() {
                $("#confirmation-modal").modal("hide");

                $(document).trigger("confirmation-modal-confirmed", $("#confirmation-modal"));
            });

            $("#confirmation-modal").on("hidden.bs.modal", function() {
                $("#confirmation-modal-confirm").off("click");
                $("#confirmation-modal-cancel").off("click");
            });
        } else {
            perform(route, callback, method);
        }
    });
};
